import React from 'react';
import _ from 'lodash';
import { useHistory, matchPath } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { RootState } from '../../../configs/store';
import useIsMobile from '../../../hooks/useIsMobile';
import Banner from 'src/components/Banner/Banner/Banner';
import BannerCarousel from 'src/components/Banner/BannerCarousel/BannerCarousel';
import { isBefore, isAfter } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

export default function BannerContainer({ data, preview }:{
    data: { banners: Record<string, any>[ ], configuration?: Record<string, any>[] },
    preview?: boolean
  }) {
  const { selectedTimezone } = useSelector((state: RootState) => state.odds);
  const mobile = useIsMobile();
  const history = useHistory();
  let banners = data.banners;
  const match = matchPath(history.location.pathname, {
    path: ['/lotto', '/sports-betting/:type', '/racing/:type'],
    exact: true,
    strict: true
  });

  if (!preview) {
    banners = _.filter(banners, banner => {
      if (mobile && (banner?.showOptions?.show === 'Mobile' || banner?.showOptions?.show === 'All')) return true;
      if (!mobile && (banner?.showOptions?.show === 'Desktop' || banner?.showOptions?.show === 'All')) return true;

      return false;
    });

    banners = _.filter(banners, banner => {
      if (match && (match.path.includes(banner.showOptions.product.toLowerCase()) || banner.showOptions.product === 'All')) return true;

      return false;
    });

    banners = _.filter(banners, banner => {
      if (banner.showOptions.from &&
        isBefore(utcToZonedTime(banner.showOptions.from, selectedTimezone), new Date()) || !banner.showOptions.from) return true;
      if (banner.showOptions.to &&
        isAfter(utcToZonedTime(banner.showOptions.to, selectedTimezone), new Date()) || !banner.showOptions.to) return true;

      return false;
    });
  }

  if (banners.length === 0) return null;

  return banners.length >= 2 ? <BannerCarousel data={ banners } configuration={ data?.configuration } /> : <Banner data={ banners[0] } />;
}
